import { create } from 'zustand';

type ModalSlideDirection = 'left' | 'right' | 'up' | 'down';

type ModalSlideSize = {
    pcWidth?: string;
    mbWidth?: string;
    height?: string;
};

export type ModalSlideItem = {
    id: string;
    isHeaderLog?: boolean;
    component: React.ReactNode;
    size?: ModalSlideSize;
    direction?: ModalSlideDirection;
};

type ModalSlideStore = {
    slides: ModalSlideItem[];
    openModalSlide: (modal: ModalSlideItem) => void;
    closeModalSlide: (id?: string) => void;
    closeAllModalSlides: () => void;
};

export const useModalSlideStore = create<ModalSlideStore>((set) => ({
    slides: [],

    openModalSlide: (modal: ModalSlideItem) =>
        set((state) => {
            if (state.slides.some((slide) => slide.id === modal.id)) return state;
            return { slides: [...state.slides, modal] };
        }),

    closeModalSlide: (id?: string) =>
        set((state) => {
            if (!id) return { slides: state.slides.slice(0, -1) };
            const index = state.slides.findIndex((slide) => slide.id === id);
            if (index === -1) return state;
            return { slides: state.slides.slice(0, index) };
        }),

    closeAllModalSlides: () => set({ slides: [] }),
}));
